import React from "react"
import { createRoot } from "react-dom/client"
import { createBrowserHistory as createHistory } from "history"

// First: every DOMPurify.sanitize in the app goes through its hooks (utils/purify.js)
import "./utils/purify"
// A tab left open across a deploy reloads once instead of showing blank screens
import "./staleBuildReload"
import App from "./App"

import { abortFileStreams } from "./services/file/file.service"
import ErrorBoundary from "./ErrorBoundary"
import { delAllExpiredCache } from "./utils/cache"
import * as serviceWorker from "./serviceWorker"
import DriveDRoutingComponent from "./drive/DriveDRouting"
import AgreementPage from "./comp/AgreementPage"

const history = createHistory()
const data = {
    title: "missionX WORK SPACE",
    meta: {
        name: {
            /**
             * Prevent search engine indexing
             */
            robots: "noindex,nofollow",
        },
    },
}

/** The workspace is never indexed by search engines (was react-document-meta). */
function applyWorkspaceMeta() {
    document.title = data.title
    const robots = document.createElement("meta")
    robots.name = "robots"
    robots.content = data.meta.name.robots
    document.head.appendChild(robots)
}

let isDriveFileView = false
let isAgreementView = false
let urlParams

try {
    urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("drive") === "d") {
        isDriveFileView = true
    }
} catch (err) {}

try {
    /**
     * The agreement / privacy / disclaimer / cookie content is also served as its own
     * public page, eg app.missionx.ai/agreement, with no app and no login behind it
     */
    const path = window.location.pathname.toLowerCase().replace(/\/+$/, "")

    if (path === "/agreement" || path === "/agreements") {
        isAgreementView = true
    }
} catch (err) {}

class AppComponent extends React.Component {
    stripeEl
    history

    constructor(props) {
        super(props)

        this.state = { stripe: null }

        this.appRef = React.createRef()
    }

    componentDidMount() {
        delAllExpiredCache().catch(() => {
            // Nothing
        })

        window.addEventListener("beforeunload", abortFileStreams)
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", abortFileStreams)
    }

    render() {
        return (
            <ErrorBoundary app={this.appRef.current}>
                <App ref={this.appRef} />
            </ErrorBoundary>
        )
    }
}

if (!isAgreementView && !isDriveFileView) {
    applyWorkspaceMeta()
}

createRoot(document.getElementById("root")).render(
    isAgreementView ? (
        <AgreementPage />
    ) : isDriveFileView ? (
        <DriveDRoutingComponent fileId={urlParams.get("fileId")} fileName={urlParams.get("fileName")} />
    ) : (
        <AppComponent />
    ),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
